/**
 * Home component
 *
 * The section at the top of the page to display image of your
 * choice, name and title that describes your career focus.
 */

import React from "react";
import arrowSvg from "../images/down-arrow.svg";
import PropTypes from "prop-types";

/**
 * Home background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/top_background.jpg";

const imageAltText =
  "Adult female in office setting leaning against a glass wall while holding a platinum Microsoft Surface Pro 7 in tablet mode preparing to write with Microsoft Surface Pen";

const Home = ({ name, title }) => {
  return (
    <section id="home" className="min-height">
      <img className="background" src={image} alt="" />
      <img
        src={arrowSvg}
        style={{ position: "absolute", left: "50%", height: "5vw", width: "5vw", bottom: "1rem" }}
        alt={imageAltText}
      />
      <div
        style={{
          position: "absolute",
          top: "45%",
          left: "50%",
          height: "100vh",
          transform: "translateX(-50%)",
          color: "white",
          width: "auto",
        }}
      >
        <h1>{name}</h1>
        <p
          style={{
            fontSize: "3.5vw",
            fontWeight: "400",
            marginTop: "1rem",
            padding: "0 2vw",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </p>
      </div>
    </section>
  );
};

Home.defaultProps = {
  name: "",
  title: "",
};

Home.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Home;
